import React, { useState, useEffect } from "react";
import "./WelcomeAdmin.css";
import Permiso from "../../router/Permiso";
import { View, Phone } from "lucide-react";
import { SaleService } from "../../services/SaleService";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip as RechartsTooltip,
  Legend as RechartsLegend, ResponsiveContainer,
  LabelList,
  Cell
} from 'recharts';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Select from "../../components/Select";
import RadialSeparators from "../../components/RadialSeparators";

const WelcomeAdmin = ({ token, refreshTrigger = 0 }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [codeSale, setCodeSale] = useState("");
  const [clientName, setClientName] = useState("");
  const [error, setError] = useState("");
  const [errorModal, setErrorModal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [loading, setLoading] = useState(false);
  const [ventas, setVentas] = useState([]);
  const [productivityList, setProductivityList] = useState([]);
  const [productivityListValues, setProductivityListValues] = useState([]);
  const [percentStatistic, setPercentStatistic] = useState(0);
  const [monthSelected, setMonthSelected] = useState(new Date().getMonth() + 1);
  const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [modalOpened, setModalOpened] = useState(false);
  const navigate = useNavigate();
  const COLORS = ['#22b04c', '#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f', '#edc948', '#b07aa1'];

  useEffect(() => {
    fetchVentas();
    let tmpYears = [];
    for (let i = 2000; i <= new Date().getFullYear(); i++) {
      tmpYears.push({
        id: i,
        nombre: i
      });
    }
    setYears(tmpYears);
  }, [currentPage, refreshTrigger]);

  useEffect(() => {
    if (codeSale === "" && clientName === "") {
      fetchVentas();
    }
  }, [codeSale, clientName]);

  useEffect(() => {
    getStatistics();
  }, [yearSelected, monthSelected]);

  const getStatistics = async () => {
    const result = await SaleService.getStatisticsInstaladas({ token, yearSelected, monthSelected });
    const percent = result.totalInstaladas > 0 ? Math.round((result.conSeguimiento / result.totalInstaladas) * 100) : 0;
    console.log(result)
    setPercentStatistic(percent);
    const productivityList = result.detallePorUsuario.map(u =>
      ({ name: u.nombre, cantidad: u.ventas_con_seguimiento }));
    setProductivityList(productivityList)
  }

  const exportarExcel = async () => {
    try {
      const filtros = {
        desde: fechaInicio,
        hasta: fechaFin,
        dni: codeSale,
      };

      const blob = await SaleService.exportarVentasInstaladasExcel(token, filtros);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "listado_ventas.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error al exportar Excel:", error);
    }
  };

  const fetchVentas = async () => {
    setLoading(true);
    setError("");
    try {
      const { ventas, totalPaginas, totalRegistros } = await SaleService.fetchVentasInstalado({
        token,
        pagina: currentPage,
        pageSize: 20,
        desde: fechaInicio,
        hasta: fechaFin,
        dni: codeSale,
        nombre: clientName,
      });
      setVentas(ventas);
      setTotalPages(totalPaginas);
      setTotalRegistros(totalRegistros);
    } catch (err) {
      setError("Error al cargar las ventas");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ventas-admin-content">
      <div className="ventas-admin-tab-content">

        <div className="flex w-full">
          <div className="w-20">
            <div className="ventas-admin-subtitle">
              Bienvenida
            </div>
            <p>Gestión de Bienvenida</p>

            <div className="flex">
              <Select title="Año" value={yearSelected} setValue={setYearSelected} options={years} className="w-30" />
              <Select title="Mes" value={monthSelected} setValue={setMonthSelected} options={[
                {
                  id: 1,
                  nombre: 'Enero'
                },
                {
                  id: 2,
                  nombre: 'Febrero'
                },
                {
                  id: 3,
                  nombre: 'Marzo'
                },
                {
                  id: 4,
                  nombre: 'Abril'
                },
                {
                  id: 5,
                  nombre: 'Mayo'
                },
                {
                  id: 6,
                  nombre: 'Junio'
                },
                {
                  id: 7,
                  nombre: 'Julio'
                },
                {
                  id: 8,
                  nombre: 'Agosto'
                },
                {
                  id: 9,
                  nombre: 'Septiembre'
                },
                {
                  id: 10,
                  nombre: 'Octubre'
                },
                {
                  id: 11,
                  nombre: 'Noviembre'
                },
                {
                  id: 12,
                  nombre: 'Diciembre'
                },
              ]} className="ml-5 w-40" />
            </div>

          </div>
          <div className="w-20">
            <div className="ventas-admin-subtitle pb-10">
              Avance de Gestión
            </div>
            <CircularProgressbarWithChildren
              value={percentStatistic}
              text={`${percentStatistic}%`}
              strokeWidth={10}
              styles={buildStyles({
                strokeLinecap: "butt",
                pathColor: "#8a6fcb",
                textColor: "black"
              })}
            >
              <RadialSeparators
                count={12}
                style={{
                  background: "#fff",
                  width: "2px",
                  height: `${10}%`
                }}
              />
            </CircularProgressbarWithChildren>
          </div>
          <div className="w-40">
            <div className="ventas-admin-subtitle pb-10">
              Productividad
            </div>
            {productivityList.length > 0 && (
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={productivityList}>
                  <XAxis dataKey="name" />
                  <YAxis />
                  <RechartsTooltip />
                  <RechartsLegend />
                  <Bar dataKey="cantidad" name="Ventas instaladas con seguimiento">
                    {productivityList.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                    <LabelList dataKey="cantidad" position="top" />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>

        <div className="ventas-table-header">
          <h2 className="ventas-table-title">Lista de ponteciales clientes </h2>
          <div className="productos-actions">
            <Permiso permiso="export_welcome">
              <button onClick={exportarExcel} className="btn-exportar">
                Exportar a Excel
              </button>
            </Permiso>
          </div>
        </div>

        <div className="usuarios-filtros ">
          <Input title="Código de venta:" value={codeSale} setValue={setCodeSale} placeholder="Ingrese número" className="filtro-item" />
          <div className="filtro-item">
            <label>Fecha Inicio:</label>
            <input
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
          </div>
          <div className="filtro-item">
            <label>Fecha Fin:</label>
            <input
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
            />
          </div>
          <div className="filtro-item">
            <button onClick={fetchVentas} className="btn-filtrar">
              Buscar
            </button>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        {loading ? (
          <div className="loading">Cargando ventas...</div>
        ) : (
          <>
            <div className="ventas-table-wrapper">
              <table className="ventas-table">
                <thead>
                  <tr>
                    <th>Codigo</th>
                    <th>Cliente</th>
                    <th>F. Venta</th>
                    <th>Vendedor</th>
                    <th>Supervisor</th>
                    <th>Contactabilidad</th>
                    <th>Tematico</th>
                    <th>#Contact</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {ventas.map((venta) => {

                    return (
                      <tr key={venta.id}>
                        <td>{venta.codigo_venta_cliente}</td>
                        <td>
                          {venta.cliente_nombre}  {venta.cliente_apellido_paterno}  {venta.cliente_apellido_materno}
                        </td>
                        <td>{new Date(venta.fecha_venta).toLocaleDateString()}</td>
                        <td>
                          {venta.nombre_vendedor} {venta.apellido_vendedor}
                        </td>
                        <td>
                          {venta.supervisor}
                        </td>
                        <td>{venta.tematico}</td>
                        <td>{venta.contactabilidad}</td>
                        <td>{venta.item_correlativo}</td>
                        <td className="ventas-acciones">
                          <Permiso permiso="view_welcome">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => navigate(`/admin/bienvenida/registrar/${venta.id}/only`)}
                            >
                              <View size={20} />
                            </span>
                          </Permiso>
                          <Permiso permiso="add_follow_welcome">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                navigate(`/admin/bienvenida/registrar/${venta.id}`);
                              }}
                            >
                              <Phone size={20} />
                            </span>
                          </Permiso>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
              {" "}
              Total de registros: {totalRegistros}{" "}
            </span>
            {/* Paginación */}
            <div className="pagination">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
              <span>
                Página {currentPage} de {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Siguiente
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WelcomeAdmin;
